<script setup lang="ts">
import { AuthenticationFailedException } from "@/classes/errors";
import { useI18n } from "@/composables/useI18n";
import { useFabriqStore } from "@/store/fabriq";
import ErrorLayout from "@/components/errors/ErrorLayout.vue";
import AppVersion from "@/components/ui/AppVersion.vue";
import { IonButton } from "@ionic/vue";

defineProps<{ error: AuthenticationFailedException }>();

const { t } = useI18n();
const fabriqStore = useFabriqStore();
</script>

<template>
  <error-layout>
    <div />
    <div class="ion-padding">
      <div class="ion-padding error-text">
        <span v-if="error.reason === 'invalidCredentials'">
          {{
            t("common.wrongCredentialsForDomain", {
              domain: fabriqStore.url,
            })
          }}
        </span>
        <span v-else-if="error.reason === 'failedToFinalize'">
          {{
            t("common.failedToFinalizeLogin", {
              domain: fabriqStore.url,
            })
          }}
        </span>
      </div>
      <ion-button
        expand="block"
        color="secondary"
        mode="ios"
        @click="() => fabriqStore.setInitializationState({ type: 'done' })"
      >
        {{ t("login.retry") }}
      </ion-button>
    </div>
    <AppVersion :version="fabriqStore.version" position="relative" />
  </error-layout>
</template>

<style scoped>
.error-text {
  text-align: center;
}
</style>
